import { render, staticRenderFns } from "./home-shimmer.vue?vue&type=template&id=0187be10&"
import script from "./home-shimmer.vue?vue&type=script&lang=js&"
export * from "./home-shimmer.vue?vue&type=script&lang=js&"
import style0 from "./home-shimmer.vue?vue&type=style&index=0&id=0187be10&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports